export default {
    viewSelector: {
        trendSelection: 'Trend selection',
        evaluation: 'Evaluation',
        tooltip: 'First select trends for evaluation to be able to activate the rating options.'
    }
}
